var QUESTIONS = [
  {
    id: "product",
    title: "Product",
    icon: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.39059 1.72416C8.1406 1.4741 7.80151 1.33357 7.44792 1.3335H2.66659C2.31296 1.3335 1.97382 1.47397 1.72378 1.72402C1.47373 1.97407 1.33325 2.31321 1.33325 2.66683V7.44816C1.33333 7.80176 1.47385 8.14084 1.72392 8.39083L7.52659 14.1935C7.82959 14.4946 8.23942 14.6636 8.66659 14.6636C9.09375 14.6636 9.50358 14.4946 9.80659 14.1935L14.1933 9.80683C14.4943 9.50382 14.6633 9.094 14.6633 8.66683C14.6633 8.23966 14.4943 7.82984 14.1933 7.52683L8.39059 1.72416Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.00008 5.33317C5.18418 5.33317 5.33341 5.18393 5.33341 4.99984C5.33341 4.81574 5.18418 4.6665 5.00008 4.6665C4.81599 4.6665 4.66675 4.81574 4.66675 4.99984C4.66675 5.18393 4.81599 5.33317 5.00008 5.33317Z" fill="black" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
    questions: [
      {
        id: "product_1",
        tag: "Product",
        tagSub: "What it is.",
        title: "Describe your product or product range in one sentence or a few words.",
        hint: "Think about how you would describe it to someone who has never heard of it before.",
        example: "We make toothpaste tablets — a solid, plastic-free alternative to conventional toothpaste that you chew into a paste and brush with normally.",
        scope: "Describe only what the product physically is in one sentence. Do not mention the customer, the problem it solves, pricing, sustainability claims, or brand values."
      },
      {
        id: "product_2",
        tag: "Product",
        tagSub: "Your industry.",
        title: "Which industry best describes the space you sell in?",
        hint: "Think about the industry your product belongs to.",
        example: "Oral care.",
        scope: "Describe the industry your product belongs to. Do not mention the product, the customer, the problem it solves, pricing, sustainability claims, or brand values.",
        instructions: "Make it one or two words."
      },
      {
        id: "product_3",
        tag: "Product",
        tagSub: "Type of purchase.",
        title: "What type of purchase is your product?",
        hint: "Think about the main reason someone buys it — to solve a problem, to feel something, to express themselves, or to experience something.",
        example: "Problem-solving — people buy it because they want to stop throwing away plastic tubes every month without giving up a product that works.",
        scope: "Describe the main reason someone buys it — to solve a problem, to feel something, to express themselves, or to experience something.",
        instructions: "Make it one or two words. Dont elaborate on the reason. Just give a plain reason."
      },
      {
        id: "product_3b",
        tag: "Product",
        tagSub: "Amount of product.",
        title: "How many products do you offer?",
        hint: "Think about the total number of products you offer. Not amount of SKU's or variants.",
        example: "55",
        scope: "Give a plain number, dont mention anything else then just a number.",
        instructions: "Dont explain the number. Just give a plain number."
      },
      {
        id: "product_4",
        tag: "Product",
        tagSub: "Product types.",
        title: "What are the different product types you offer?",
        hint: "Think about the different categories of products you offer.",
        example: "Toothpaste tablets, mouthwash tablets, whitening tablets, and toothbrushes.",
        scope: "List the fundamentally different types. Don't count different sizes or versions of the same product.",
        instructions: "Don't give descriptions of the product types. Just list the plain product types."
      },
      {
        id: "product_5",
        tag: "Product",
        tagSub: "Collections.",
        title: "How do you organize your products into collections or categories?",
        hint: "Think about the logic behind how your products are grouped.",
        example: "By flavour, product type, subscription-based products, toothbrushes, and whitening kits.",
        instructions: "Don't give descriptions of the collections. Just list the plain collection names."
      },
      {
        id: "product_6",
        tag: "Product",
        tagSub: "Order options.",
        title: "What options does a customer choose from when ordering your product?",
        hint: "Think about every choice a customer has to make before they can complete their order.",
        example: "For toothbrushes: colour and brush set amount. For toothpaste tablets: flavour, tablet count",
        scope: "Don't mention payment options or delivery options. Don't mention bundles or discounts.",
        instructions: "Think about the product variants like colour, size, or flavour. Think about the characteristics a customer can choose from and what variants have to be choosen before they add a product to their cart."
      },
      {
        id: "product_7",
        tag: "Product",
        tagSub: "Standout qualities.",
        title: "What are the key qualities that make your product stand out?",
        hint: "Think about what makes your product better and different from everything else available.",
        example: "No plastic packaging, no water or fillers, fluoride included, TSA approved, and works exactly like regular toothpaste."
      },
      {
        id: "product_7b",
        tag: "Product",
        tagSub: "Ingredients or materials.",
        title: "What are the key ingredients or materials your product is made from?",
        hint: "Think about the main components — what it's actually made of.",
        example: "Fluoride, xylitol, hydrated silica, and natural mint flavouring — all naturally derived, no microplastics, no SLS, no artificial preservatives."
      },
      {
        id: "product_8",
        tag: "Product",
        tagSub: "Made or sourced.",
        title: "How is your product made or sourced?",
        hint: "Think about the process or origin behind your product — where it comes from and how it gets made.",
        example: "Made in small batches in a UK certified facility using naturally derived ingredients."
      },
      {
        id: "product_9",
        tag: "Product",
        tagSub: "Sell outs.",
        title: "Do any of your products sell out — and if so, why?",
        hint: "Think about whether it happens intentionally or unexpectedly — and what causes it.",
        example: "Our charcoal whitening tablets sell out after any press feature — we keep batches small deliberately so they stay fresh."
      }
    ]
  },
  {
    id: "customer",
    title: "Customer",
    icon: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.00008 8.66667C9.84103 8.66667 11.3334 7.17428 11.3334 5.33333C11.3334 3.49238 9.84103 2 8.00008 2C6.15913 2 4.66675 3.49238 4.66675 5.33333C4.66675 7.17428 6.15913 8.66667 8.00008 8.66667Z" stroke="#232323" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.3334 13.9998C13.3334 12.5853 12.7715 11.2288 11.7713 10.2286C10.7711 9.22841 9.41457 8.6665 8.00008 8.6665C6.58559 8.6665 5.22904 9.22841 4.22885 10.2286C3.22865 11.2288 2.66675 12.5853 2.66675 13.9998" stroke="#232323" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`,
    questions: [
      {
        id: "customer_1",
        tag: "Customer",
        tagSub: "Who they are.",
        title: "What type of person is your typical customer?",
        hint: "Think about their lifestyle or identity — e.g. a health-conscious professional, a busy parent, a passionate hobbyist.",
        example: "Environmentally conscious professionals."
      },
      {
        id: "customer_2",
        tag: "Customer",
        tagSub: "Age range.",
        title: "What age range best describes your typical customer?",
        hint: "Focus on the range most likely to buy — not everyone who could.",
        example: "25 to 40."
      },
      {
        id: "customer_3",
        tag: "Customer",
        tagSub: "Gender.",
        title: "Who is your product primarily made for in terms of gender?",
        hint: "e.g. women, men, non-binary, or everyone equally.",
        example: "Skews female — about 65% of our customers are women."
      },
      {
        id: "customer_4",
        tag: "Customer",
        tagSub: "Interests.",
        title: "What are your customers interested in or passionate about?",
        hint: "Think about what they do in their free time or what they care about.",
        example: "Sustainability, clean living, yoga and wellness, travel, and nutrition."
      }
    ]
  },
  {
    id: "current_situation",
    title: "Current Situation",
    icon: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.66675 14.6668V2.66683C2.66675 2.56333 2.69084 2.46126 2.73713 2.36869C2.78341 2.27612 2.85062 2.19559 2.93341 2.1335C3.6258 1.61421 4.46793 1.3335 5.33341 1.3335C7.33341 1.3335 8.66675 2.66683 10.2221 2.66683C11.111 2.66683 11.7925 2.48905 12.2667 2.1335C12.3658 2.05921 12.4836 2.01398 12.6069 2.00286C12.7302 1.99174 12.8542 2.01518 12.9649 2.07054C13.0756 2.12591 13.1688 2.21102 13.2338 2.31634C13.2989 2.42166 13.3334 2.54302 13.3334 2.66683V9.3335C13.3334 9.43699 13.3093 9.53907 13.263 9.63164C13.2167 9.72421 13.1495 9.80473 13.0667 9.86683C12.3744 10.3861 11.5322 10.6668 10.6667 10.6668C8.66675 10.6668 7.33341 9.3335 5.33341 9.3335C4.34949 9.33352 3.4001 9.69619 2.66675 10.3522" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
    questions: [
      {
        id: "current_situation_1",
        tag: "Current situation",
        tagSub: "The trigger.",
        title: "What moment or event made your customer start looking for your type of product?",
        hint: "Think about a shift in their situation or an upcoming moment.",
        example: "They watched a documentary about ocean plastic, or cleared out their bathroom and were shocked by how many empty tubes they'd gone through."
      },
      {
        id: "current_situation_2",
        tag: "Current situation",
        tagSub: "Pains and frustrations.",
        title: "What pains or frustrations does your customer experience before finding your product?",
        hint: "Think about what bothers them most.",
        example: "They feel guilty throwing away plastic tubes every month and feel bad about the impact it has on our planet."
      },
      {
        id: "current_situation_3",
        tag: "Current situation",
        tagSub: "How they currently feel.",
        title: "What emotional state does your customer want to move away from?",
        hint: "Think about the feeling that pushes them to look for a solution.",
        example: "They feel like a hypocrite — ashamed that despite caring deeply about the planet, their bathroom bin tells a different story."
      },
      {
        id: "current_situation_4",
        tag: "Current situation",
        tagSub: "What kept them stuck.",
        title: "Why hasn't your customer found what they were looking for until now?",
        hint: "Think about what barrier kept them stuck — doubt, cost, lack of options, or not knowing something like this existed.",
        example: "They assumed switching would mean compromising on performance — they didn't believe a tablet could clean as well as regular toothpaste."
      },
      {
        id: "current_situation_5",
        tag: "Current situation",
        tagSub: "Risks and doubts.",
        title: "What risks or doubts does your customer have before buying?",
        hint: "Think about what could go wrong in their mind.",
        example: "They worry it won't foam properly, the taste will be weird, or their dentist will say it's not effective."
      }
    ]
  },
  {
    id: "transformation_mechanism",
    title: "Transformation Mechanism",
    icon: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.44729 2.75711C6.48402 2.37067 6.66351 2.01181 6.95069 1.75063C7.23787 1.48945 7.61211 1.34473 8.00029 1.34473C8.38847 1.34473 8.76271 1.48945 9.04989 1.75063C9.33707 2.01181 9.51656 2.37067 9.55329 2.75711C9.57537 3.00675 9.65727 3.24739 9.79205 3.45867C9.92683 3.66995 10.1105 3.84565 10.3276 3.97089C10.5447 4.09614 10.7887 4.16724 11.0391 4.17819C11.2895 4.18913 11.5388 4.1396 11.766 4.03378C12.1187 3.87363 12.5184 3.85045 12.8873 3.96877C13.2562 4.08708 13.5678 4.33841 13.7616 4.67385C13.9554 5.00928 14.0175 5.40482 13.9357 5.78349C13.854 6.16216 13.6342 6.49685 13.3193 6.72244C13.1142 6.86634 12.9468 7.05751 12.8312 7.27979C12.7157 7.50207 12.6553 7.74891 12.6553 7.99944C12.6553 8.24997 12.7157 8.49681 12.8312 8.71909C12.9468 8.94137 13.1142 9.13254 13.3193 9.27644C13.6342 9.50203 13.854 9.83673 13.9357 10.2154C14.0175 10.5941 13.9554 10.9896 13.7616 11.325C13.5678 11.6605 13.2562 11.9118 12.8873 12.0301C12.5184 12.1484 12.1187 12.1253 11.766 11.9651C11.5388 11.8593 11.2895 11.8097 11.0391 11.8207C10.7887 11.8316 10.5447 11.9027 10.3276 12.028C10.1105 12.1532 9.92683 12.3289 9.79205 12.5402C9.65727 12.7515 9.57537 12.9921 9.55329 13.2418C9.51656 13.6282 9.33707 13.9871 9.04989 14.2483C8.76271 14.5094 8.38847 14.6542 8.00029 14.6542C7.61211 14.6542 7.23787 14.5094 6.95069 14.2483C6.66351 13.9871 6.48402 13.6282 6.44729 13.2418C6.42525 12.9921 6.34336 12.7513 6.20854 12.54C6.07371 12.3286 5.88994 12.1529 5.67278 12.0276C5.45562 11.9023 5.21147 11.8313 4.96101 11.8204C4.71055 11.8095 4.46116 11.8591 4.23396 11.9651C3.88122 12.1253 3.48151 12.1484 3.11263 12.0301C2.74374 11.9118 2.43207 11.6605 2.23828 11.325C2.04449 10.9896 1.98244 10.5941 2.0642 10.2154C2.14596 9.83673 2.36569 9.50203 2.68063 9.27644C2.88571 9.13254 3.05311 8.94137 3.16868 8.71909C3.28426 8.49681 3.34459 8.24997 3.34459 7.99944C3.34459 7.74891 3.28426 7.50207 3.16868 7.27979C3.05311 7.05751 2.88571 6.86634 2.68063 6.72244C2.36614 6.49674 2.14679 6.16217 2.06523 5.78376C1.98366 5.40535 2.0457 5.01014 2.23928 4.67492C2.43287 4.3397 2.74417 4.08843 3.11269 3.96994C3.4812 3.85144 3.88061 3.8742 4.23329 4.03378C4.46046 4.1396 4.70979 4.18913 4.96016 4.17819C5.21053 4.16724 5.45458 4.09614 5.67165 3.97089C5.88872 3.84565 6.07242 3.66995 6.2072 3.45867C6.34198 3.24739 6.42388 3.00675 6.44596 2.75711" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`,
    questions: [
      {
        id: "transformation_mechanism_1",
        tag: "Transformation mechanism",
        tagSub: "The job to be done.",
        title: "What job does your customer want your product to do?",
        hint: "Think about the specific task, goal, or progress your customer is trying to make.",
        example: "Clean their teeth effectively every day without contributing to plastic waste."
      },
      {
        id: "transformation_mechanism_2",
        tag: "Transformation mechanism",
        tagSub: "How it works.",
        title: "How does your product actually deliver the result?",
        hint: "Think about the specific process, method, or ingredient that makes the difference.",
        example: "You chew the tablet for a few seconds, it turns into a paste, and you brush normally — the fluoride and natural abrasives do the same job as conventional toothpaste."
      },
      {
        id: "transformation_mechanism_3",
        tag: "Transformation mechanism",
        tagSub: "Proof.",
        title: "What evidence or proof shows that your product delivers on this promise?",
        hint: "Think about what evidence or proof you have that supports your claim.",
        example: "Over 2,000 five-star reviews, dentist endorsements, independent lab testing confirming fluoride levels meet EU standards, and the fact that a single person throws away up to 300 plastic toothpaste tubes in their lifetime."
      },
      {
        id: "transformation_mechanism_4",
        tag: "Transformation mechanism",
        tagSub: "What they must believe.",
        title: "What must your customer believe about your product before they commit?",
        hint: "Think about what would make them go from curious to convinced.",
        example: "That a tablet cleans just as effectively as regular paste."
      }
    ]
  },
  {
    id: "transformation",
    title: "Transformation",
    icon: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.34472 1.87581C7.37328 1.72287 7.45443 1.58475 7.57412 1.48535C7.6938 1.38595 7.84447 1.33154 8.00005 1.33154C8.15563 1.33154 8.3063 1.38595 8.42599 1.48535C8.54567 1.58475 8.62682 1.72287 8.65538 1.87581L9.35605 5.58114C9.40581 5.84457 9.53383 6.08688 9.7234 6.27645C9.91297 6.46602 10.1553 6.59404 10.4187 6.64381L14.1241 7.34447C14.277 7.37304 14.4151 7.45419 14.5145 7.57387C14.6139 7.69355 14.6683 7.84423 14.6683 7.99981C14.6683 8.15538 14.6139 8.30606 14.5145 8.42574C14.4151 8.54542 14.277 8.62657 14.1241 8.65514L10.4187 9.35581C10.1553 9.40557 9.91297 9.53359 9.7234 9.72316C9.53383 9.91273 9.40581 10.155 9.35605 10.4185L8.65538 14.1238C8.62682 14.2767 8.54567 14.4149 8.42599 14.5143C8.3063 14.6137 8.15563 14.6681 8.00005 14.6681C7.84447 14.6681 7.6938 14.6137 7.57412 14.5143C7.45443 14.4149 7.37328 14.2767 7.34472 14.1238L6.64405 10.4185C6.59429 10.155 6.46627 9.91273 6.2767 9.72316C6.08713 9.53359 5.84482 9.40557 5.58138 9.35581L1.87605 8.65514C1.72312 8.62657 1.58499 8.54542 1.4856 8.42574C1.3862 8.30606 1.33179 8.15538 1.33179 7.99981C1.33179 7.84423 1.3862 7.69355 1.4856 7.57387C1.58499 7.45419 1.72312 7.37304 1.87605 7.34447L5.58138 6.64381C5.84482 6.59404 6.08713 6.46602 6.2767 6.27645C6.46627 6.08688 6.59429 5.84457 6.64405 5.58114L7.34472 1.87581Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.3333 1.3335V4.00016" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.6667 2.6665H12" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.66659 14.6667C3.40297 14.6667 3.99992 14.0697 3.99992 13.3333C3.99992 12.597 3.40297 12 2.66659 12C1.93021 12 1.33325 12.597 1.33325 13.3333C1.33325 14.0697 1.93021 14.6667 2.66659 14.6667Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`,
    questions: [
      {
        id: "transformation_1",
        tag: "Transformation",
        tagSub: "Pain relief.",
        title: "How does your product relieve your customer's pains or frustrations?",
        hint: "Think about what they no longer have to deal with or worry about.",
        example: "They no longer feel guilty every time they throw away a plastic tube — their bathroom routine finally matches their values."
      },
      {
        id: "transformation_2",
        tag: "Transformation",
        tagSub: "What success looks like.",
        title: "What does success look like after using your product?",
        hint: "Think about the moment your customer realises your product worked.",
        example: "They've been using it for a month, their teeth feel just as clean, and they've thrown away zero plastic."
      },
      {
        id: "transformation_3",
        tag: "Transformation",
        tagSub: "How they want to feel.",
        title: "What emotional state does your customer want to experience?",
        hint: "Think about how they want to feel after using your product.",
        example: "They want to feel proud, relieved, empowered and finally consistent — no more guilt, no more compromise, no more feeling like their values stop at the bathroom door."

      },
      {
        id: "transformation_4",
        tag: "Transformation",
        tagSub: "Identity.",
        title: "Who does your customer want to be by owning or using your product?",
        hint: "Think about the identity or version of themselves they are stepping into.",
        example: "Someone who has genuinely figured out how to live more sustainably without sacrificing quality."
      },
      {
        id: "transformation_5",
        tag: "Transformation",
        tagSub: "Social signal.",
        title: "How does your product help your customer be perceived differently by others?",
        hint: "Think about the social signal your product sends — what does owning or using it say about them?",
        example: "When guests see our glass jar on the bathroom shelf instead of a plastic tube, it signals that this person is intentional about how they live."
      }
    ]
  },
  {
    id: "brand",
    title: "Brand",
    icon: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.00008 6.6665C7.64645 6.6665 7.30731 6.80698 7.05727 7.05703C6.80722 7.30708 6.66674 7.64622 6.66674 7.99984C6.66674 8.67984 6.60007 9.67317 6.49341 10.6665" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.33341 8.74658C9.33341 10.3332 9.33341 12.9999 8.66675 14.6666" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.5266 14.0133C11.6066 13.6133 11.8133 12.48 11.8599 12" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1.33325 8.00016C1.33325 6.60095 1.7735 5.2372 2.59164 4.10209C3.40977 2.96699 4.56432 2.11808 5.89173 1.67561C7.21915 1.23314 8.65213 1.21954 9.9877 1.63674C11.3233 2.05394 12.4937 2.88079 13.3333 4.00016" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1.33325 10.6665H1.33992" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.5334 10.6665C14.6668 9.33317 14.6208 7.09717 14.5334 6.6665" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.33325 12.9998C3.66659 11.9998 3.99992 9.99984 3.99992 7.99984C3.99924 7.54575 4.0759 7.09486 4.22659 6.6665" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.7666 14.6668C5.9066 14.2268 6.0666 13.7868 6.1466 13.3335" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6 4.53346C6.60827 4.18228 7.29828 3.99745 8.00064 3.99756C8.70301 3.99767 9.39296 4.18272 10.0011 4.5341C10.6093 4.88548 11.1142 5.39079 11.4651 5.99923C11.816 6.60766 12.0005 7.29776 12 8.00012V9.33346" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`,
    questions: [
      {
        id: "brand_1",
        tag: "Brand",
        tagSub: "The origin.",
        title: "What moment or insight sparked the creation of this brand?",
        hint: "Think about the personal experience, frustration, or gap in the market that led to this brand.",
        example: "I was packing for a long trip and realised every toiletry I owned came in single-use plastic — I looked for a better option and couldn't find one I actually trusted."
      },
      {
        id: "brand_2",
        tag: "Brand",
        tagSub: "Mission.",
        title: "What is your brand's mission or purpose beyond selling products?",
        hint: "Think about the change you want to see in the world, industry or in your customer's life.",
        example: "To make sustainable oral care the obvious choice — not a compromise, not a niche thing, just the normal thing."
      },
      {
        id: "brand_3",
        tag: "Brand",
        tagSub: "Community.",
        title: "What scene, culture, or community does your brand come from or belong to?",
        hint: "Think about the roots of your brand.",
        example: "The zero-waste and conscious consumer movement — people who are rethinking their relationship with stuff and trying to consume less, better."
      },
      {
        id: "brand_4",
        tag: "Brand",
        tagSub: "Principles.",
        title: "What principles guide every decision your brand makes?",
        hint: "Think about the beliefs and values that shape your decisions — from product development or sourcing to how you communicate it.",
        example: "No plastic ever. No greenwashing. Ingredients we'd be comfortable explaining to a chemist and a five-year-old. Never sacrifice performance for sustainability."
      },
      {
        id: "brand_5",
        tag: "Brand",
        tagSub: "What you stand against.",
        title: "What beliefs does your brand stand against or disagree with?",
        hint: "Think about the norms or conventions your brand rejects — in your industry or in society.",
        example: "The idea that going green means going without — that sustainable products have to be worse, more expensive, or more complicated to use."
      },
      {
        id: "brand_6",
        tag: "Brand",
        tagSub: "Brand personality.",
        title: "If your brand were a person, how would you describe that person?",
        hint: "Think about their character, attitude, and the way they speak and carry themselves.",
        example: "Calm, informed and quietly confident — the friend who has already figured something out and shares it without making you feel bad for not knowing sooner."
      },
      {
        id: "brand_7",
        tag: "Brand",
        tagSub: "Tone of voice.",
        title: "How would you describe your brand's tone of voice?",
        hint: "Think about how your brand sounds — formal or casual, bold or gentle, serious or playful.",
        example: "Direct and warm — we don't lecture, we don't over-explain, and we never make people feel guilty."
      },
      {
        id: "brand_8",
        tag: "Brand",
        tagSub: "Differentiation.",
        title: "What makes your brand fundamentally different from others in your space?",
        hint: "Think about what your brand does, says, or stands for that no one else in your space does.",
        example: "We treat sustainability as an engineering problem, not a personality — we solve it without asking customers to compromise."
      },
      {
        id: "brand_9",
        tag: "Brand",
        tagSub: "Brand feeling.",
        title: "Which 3 keywords capture the feeling of your brand?",
        hint: "Think about the words you would want people to associate with your brand.",
        example: "Clean, considered, confident."
      }
    ]
  },
  {
    id: "competition",
    title: "Competition",
    icon: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 2V13.3333C8 13.5101 7.92976 13.6797 7.80474 13.8047C7.67971 13.9298 7.51014 14 7.33333 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V7.33333C14 7.51014 13.9298 7.67971 13.8047 7.80474C13.6797 7.92976 13.5101 8 13.3333 8H2" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.6667 12.6668L12.0001 14.0002L14.6667 11.3335" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`,
    questions: [
      {
        id: "competition_1",
        tag: "Competition",
        tagSub: "Direct competitors.",
        title: "Who are your main direct competitors?",
        hint: "Think about the brands your customer would consider instead of yours.",
        example: "Bite, Denttabs, and Georganics."
      },
      {
        id: "competition_2",
        tag: "Competition",
        tagSub: "Indirect alternatives.",
        title: "What indirect competitors or alternative solutions might your customer consider?",
        hint: "Think about what your customer might use or do instead — even if it's not the same type of product.",
        example: "Conventional toothpaste brands with recyclable packaging, or just continuing to use regular toothpaste and feeling bad about it."
      },
      {
        id: "competition_3",
        tag: "Competition",
        tagSub: "Market position.",
        title: "How does your brand position itself in the market?",
        hint: "Think about where your brand lands on the spectrum from budget to luxury.",
        example: "Premium but accessible — more expensive than drugstore toothpaste but not luxury."
      }
    ]
  },
  {
    id: "pricing",
    title: "Pricing",
    icon: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.66659 10.6665H5.33325" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.33325 5.3335H5.33325" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.6666 8H5.33325" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.66675 1.99978C2.66675 1.82297 2.73699 1.6534 2.86201 1.52838C2.98703 1.40335 3.1566 1.33311 3.33341 1.33311C3.49849 1.33221 3.6604 1.37847 3.80008 1.46645L4.42208 1.86645C4.56144 1.9555 4.72337 2.00282 4.88875 2.00282C5.05413 2.00282 5.21606 1.9555 5.35541 1.86645L5.97808 1.46645C6.11744 1.3774 6.27937 1.33008 6.44475 1.33008C6.61013 1.33008 6.77206 1.3774 6.91141 1.46645L7.53341 1.86645C7.67277 1.9555 7.8347 2.00282 8.00008 2.00282C8.16546 2.00282 8.32739 1.9555 8.46675 1.86645L9.08875 1.46645C9.22811 1.3774 9.39003 1.33008 9.55542 1.33008C9.7208 1.33008 9.88272 1.3774 10.0221 1.46645L10.6447 1.86645C10.7841 1.9555 10.946 2.00282 11.1114 2.00282C11.2768 2.00282 11.4387 1.9555 11.5781 1.86645L12.2001 1.46645C12.3398 1.37847 12.5017 1.33221 12.6667 1.33311C12.8436 1.33311 13.0131 1.40335 13.1382 1.52838C13.2632 1.6534 13.3334 1.82297 13.3334 1.99978V13.9998C13.3334 14.1766 13.2632 14.3462 13.1382 14.4712C13.0131 14.5962 12.8436 14.6664 12.6667 14.6664C12.5017 14.6674 12.3398 14.6211 12.2001 14.5331L11.5781 14.1331C11.4387 14.0441 11.2768 13.9967 11.1114 13.9967C10.946 13.9967 10.7841 14.0441 10.6447 14.1331L10.0221 14.5331C9.88272 14.6222 9.7208 14.6695 9.55542 14.6695C9.39003 14.6695 9.22811 14.6222 9.08875 14.5331L8.46675 14.1331C8.32739 14.0441 8.16546 13.9967 8.00008 13.9967C7.8347 13.9967 7.67277 14.0441 7.53341 14.1331L6.91141 14.5331C6.77206 14.6222 6.61013 14.6695 6.44475 14.6695C6.27937 14.6695 6.11744 14.6222 5.97808 14.5331L5.35541 14.1331C5.21606 14.0441 5.05413 13.9967 4.88875 13.9967C4.72337 13.9967 4.56144 14.0441 4.42208 14.1331L3.80008 14.5331C3.6604 14.6211 3.49849 14.6674 3.33341 14.6664C3.1566 14.6664 2.98703 14.5962 2.86201 14.4712C2.73699 14.3462 2.66675 14.1766 2.66675 13.9998V1.99978Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`,
    questions: [
      {
        id: "pricing_1",
        tag: "Pricing",
        tagSub: "Price range.",
        title: "What are the general price ranges across your catalog?",
        hint: "Give a rough range — from your most affordable to your most expensive product.",
        example: "£8 for a starter pack up to £28 for a 90-tablet bundle with a refillable glass jar."
      },
      {
        id: "pricing_2",
        tag: "Pricing",
        tagSub: "Price justification.",
        title: "Why is your product priced the way it is?",
        hint: "Think about what justifies your price — e.g. quality, rarity, ethical sourcing, simplicity, or brand status.",
        example: "Higher quality ingredients, plastic-free packaging, and small batch manufacturing — it costs more to make it properly."
      },
      {
        id: "pricing_3",
        tag: "Pricing",
        tagSub: "How price should feel.",
        title: "How should your price feel to your customer?",
        hint: "Think about whether it should feel like a bargain, a fair exchange, an investment, or a luxury treat.",
        example: "A fair exchange — paying a bit more than a supermarket tube but getting something they feel good about buying."
      },
      {
        id: "pricing_4",
        tag: "Pricing",
        tagSub: "Purchase decision.",
        title: "Is your product a planned purchase or an impulse buy?",
        hint: "Think about the decision timeline — minutes or months?",
        example: "Mostly planned — people find us after actively researching plastic-free alternatives."
      },
      {
        id: "pricing_5",
        tag: "Pricing",
        tagSub: "Perceived value.",
        title: "What makes your customer feel your price is worth paying?",
        hint: "Think about the signals that justify your price — e.g. packaging, ingredients, brand story, scarcity, or craftsmanship.",
        example: "The glass jar feels premium and the ingredient list is clean and short."
      }
    ]
  },
  {
    id: "offers",
    title: "Offers",
    icon: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.33333 8.00016H8.66667C9.02029 8.00016 9.35943 7.85969 9.60948 7.60964C9.85952 7.35959 10 7.02045 10 6.66683C10 6.31321 9.85952 5.97407 9.60948 5.72402C9.35943 5.47397 9.02029 5.3335 8.66667 5.3335H6.66667C6.26667 5.3335 5.93333 5.46683 5.73333 5.7335L2 9.3335" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.66675 12.0002L5.73341 11.0668C5.93342 10.8002 6.26675 10.6668 6.66675 10.6668H9.33341C10.0667 10.6668 10.7334 10.4002 11.2001 9.86685L14.2667 6.93351C14.524 6.6904 14.6742 6.35505 14.6842 6.00123C14.6942 5.64741 14.5632 5.30411 14.3201 5.04685C14.077 4.78959 13.7416 4.63944 13.3878 4.62944C13.034 4.61944 12.6907 4.7504 12.4334 4.99351L9.63341 7.59351" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1.33325 8.6665L5.33325 12.6665" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`,
    questions: [
      {
        id: "offers_1",
        tag: "Offers",
        tagSub: "Buying behaviour.",
        title: "When your customer buys, do they typically buy one product or multiple at once?",
        hint: "Are there combinations that naturally go together?",
        example: "Usually two — toothpaste tablets plus mouthwash tablets are the most common combination."
      },
      {
        id: "offers_2",
        tag: "Offers",
        tagSub: "Product tiers.",
        title: "Are there natural tiers or upgrades within your product range?",
        hint: "Think about whether you have a starter, mid-range, and premium version of your product.",
        example: "Starter pack for first-timers, standard refill bag for regulars, and the glass jar bundle as the premium version."
      },
      {
        id: "offers_3",
        tag: "Offers",
        tagSub: "Bundles and incentives.",
        title: "Do you currently use bundles, volume discounts, or spend-based incentives?",
        hint: "Think about any deals or incentives you currently offer to encourage a bigger purchase.",
        example: "We have a routine bundle that combines our most popular products, and free shipping above a certain order value."
      },
      {
        id: "offers_4",
        tag: "Offers",
        tagSub: "Replenishment.",
        title: "Are there products your customers need to replenish regularly?",
        hint: "Think about how long your product lasts before a customer needs to buy again.",
        example: "Yes — a pack of 60 tablets lasts about two months, so most customers reorder every 6 to 8 weeks."
      },
      {
        id: "offers_5",
        tag: "Offers",
        tagSub: "Gifting.",
        title: "Are your products commonly given as gifts?",
        hint: "Think about whether gifting plays a role in how your product is purchased and presented.",
        example: "Yes — especially around Christmas. The glass jar makes it feel like a proper gift."
      },
      {
        id: "offers_6",
        tag: "Offers",
        tagSub: "Discounting.",
        title: "Do you ever discount your products?",
        hint: "e.g. seasonal sales, launch discounts, loyalty rewards, or never.",
        example: "Rarely — one sale a year in January and a small loyalty discount for subscribers."
      },
      {
        id: "offers_7",
        tag: "Offers",
        tagSub: "Discount feeling.",
        title: "When you discount, how should it feel to your customer?",
        hint: "Think about whether it should feel like a reward, a rare occasion, or a celebration.",
        example: "A reward for loyalty — not a clearance event."
      }
    ]
  },
  {
    id: "marketing",
    title: "Marketing",
    icon: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.6666 11.3333C14.6666 11.687 14.5261 12.0261 14.2761 12.2761C14.026 12.5262 13.6869 12.6667 13.3333 12.6667H4.55192C4.19833 12.6667 3.85924 12.8073 3.60925 13.0573L2.14125 14.5253C2.07506 14.5915 1.99072 14.6366 1.89891 14.6548C1.8071 14.6731 1.71194 14.6637 1.62546 14.6279C1.53897 14.5921 1.46505 14.5314 1.41304 14.4536C1.36103 14.3758 1.33326 14.2843 1.33325 14.1907V3.33333C1.33325 2.97971 1.47373 2.64057 1.72378 2.39052C1.97382 2.14048 2.31296 2 2.66659 2H13.3333C13.6869 2 14.026 2.14048 14.2761 2.39052C14.5261 2.64057 14.6666 2.97971 14.6666 3.33333V11.3333Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`,
    questions: [
      {
        id: "marketing_1",
        tag: "Marketing",
        tagSub: "Channels.",
        title: "Which channels do you currently use to reach your customers?",
        hint: "Think about every channel you use to send traffic to your brand — paid, organic, or word of mouth.",
        example: "Instagram and TikTok organic, Meta paid ads, email, and word of mouth."
      },
      {
        id: "marketing_2",
        tag: "Marketing",
        tagSub: "Content.",
        title: "What kind of content do you create to attract and engage your customers?",
        hint: "e.g. educational content, inspirational stories, product showcases, behind the scenes, or community driven content.",
        example: "Mostly educational — how it works, what's in it, why plastic-free matters — mixed with UGC from customers showing their plastic-free bathroom setups."
      },
      {
        id: "marketing_3",
        tag: "Marketing",
        tagSub: "What's working.",
        title: "Which marketing activities are currently driving the most results for your brand?",
        hint: "Think about which channels or activities gives you the highest return on investment to your time and money.",
        example: "Email is our highest ROI channel, and TikTok organic drives most of our new traffic."
      },
      {
        id: "marketing_4",
        tag: "Marketing",
        tagSub: "Marketing angle.",
        title: "What angle does your brand use to stand out in its marketing?",
        hint: "Think about the unique perspective or hook your brand leads with — e.g. health, sustainability, simplicity, luxury.",
        example: "We lead with simplicity and effectiveness — same result, no plastic, easier than you think."
      }
    ]
  },
  {
    id: "customer_journey",
    title: "Customer Journey",
    icon: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.404 3.70185C9.58907 3.79433 9.79312 3.84247 10 3.84247C10.2069 3.84247 10.4109 3.79433 10.596 3.70185L13.0353 2.48185C13.1371 2.43102 13.2501 2.40705 13.3637 2.41223C13.4773 2.4174 13.5876 2.45154 13.6843 2.5114C13.781 2.57126 13.8607 2.65486 13.916 2.75424C13.9713 2.85361 14.0002 2.96547 14 3.07918V11.5885C13.9999 11.7123 13.9654 11.8336 13.9003 11.9389C13.8352 12.0441 13.7421 12.1292 13.6313 12.1845L10.596 13.7025C10.4109 13.795 10.2069 13.8431 10 13.8431C9.79312 13.8431 9.58907 13.795 9.404 13.7025L6.596 12.2985C6.41094 12.206 6.20689 12.1579 6 12.1579C5.79312 12.1579 5.58907 12.206 5.404 12.2985L2.96467 13.5185C2.8629 13.5694 2.74982 13.5933 2.63617 13.5881C2.52253 13.5829 2.41211 13.5487 2.31541 13.4888C2.21872 13.4288 2.13898 13.3452 2.08377 13.2457C2.02856 13.1462 1.99972 13.0343 2 12.9205V4.41185C2.00007 4.28807 2.03459 4.16676 2.0997 4.0615C2.16482 3.95623 2.25795 3.87118 2.36867 3.81585L5.404 2.29785C5.58907 2.20537 5.79312 2.15723 6 2.15723C6.20689 2.15723 6.41094 2.20537 6.596 2.29785L9.404 3.70185Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 3.84277V13.8428" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6 2.15723V12.1572" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`,
    questions: [
      {
        id: "customer_journey_1",
        tag: "Customer journey",
        tagSub: "Problem awareness.",
        title: "Does your customer know they have a problem before they find your brand?",
        hint: "Think about whether they are actively looking for a solution or whether your brand makes them aware of the problem for the first time.",
        example: "Usually yes — most already know they want to reduce plastic, they just haven't found a toothpaste solution they trust yet."
      },
      {
        id: "customer_journey_2",
        tag: "Customer journey",
        tagSub: "Solution awareness.",
        title: "Does your customer know what type of solution they are looking for before they find your brand?",
        hint: "Think about whether they already know what kind of product they need, or whether they're still figuring that out.",
        example: "About half know they're looking for a plastic-free toothpaste — the other half discover tablets exist through us."
      },
      {
        id: "customer_journey_3",
        tag: "Customer journey",
        tagSub: "Comparing options.",
        title: "Is your customer already comparing different options when they find your brand?",
        hint: "Think about whether they come to you with a shortlist in mind or whether your brand is the first they've seriously considered.",
        example: "Often yes — they've usually looked at one or two other tablet brands and are comparing on ingredients, price, and reviews."
      },
      {
        id: "customer_journey_4",
        tag: "Customer journey",
        tagSub: "Content consumption.",
        title: "What kinds of content is your customer actively consuming during their journey?",
        hint: "Think about whether they view educational content, look for comparisons, scroll social media, or seek motivation and inspiration online.",
        example: "Reddit threads about plastic-free swaps, YouTube reviews, TikTok bathroom transformation videos, and Google searches for whether toothpaste tablets actually work."
      },
      {
        id: "customer_journey_5",
        tag: "Customer journey",
        tagSub: "First encounter.",
        title: "How does your customer typically encounter your brand for the first time?",
        hint: "Think about whether they find you through an ad, social media, a friend's recommendation, Google search, or stumble across you in a store or at an event.",
        example: "Most commonly through a TikTok video or a friend recommending us — secondarily through Google."
      },
      {
        id: "customer_journey_6",
        tag: "Customer journey",
        tagSub: "Alternatives considered.",
        title: "What kinds of solutions or alternatives might they consider first — and why might those fall short?",
        hint: "Think about what else they might try or look at — other brands, DIY solutions, or doing nothing at all.",
        example: "Bamboo-packaged conventional toothpaste — but they realise it's still paste in a different wrapper."
      },
      {
        id: "customer_journey_7",
        tag: "Customer journey",
        tagSub: "Mindset shift.",
        title: "What shift in thinking needs to happen for them to believe your type of product?",
        hint: "Think about the mental barrier or misconception your customer needs to overcome before they're open to buying.",
        example: "They need to stop assuming that format change means performance change."
      },
      {
        id: "customer_journey_8",
        tag: "Customer journey",
        tagSub: "Pre-purchase doubts.",
        title: "What doubts, concerns, or questions do customers have right before they buy?",
        hint: "Think about what makes them feel uncertain at the moment of decision.",
        example: "Will it foam? Will my teeth feel clean? Is the fluoride level safe? Can I return it if I hate the taste?"
      },
      {
        id: "customer_journey_10",
        tag: "Customer journey",
        tagSub: "Confidence factors.",
        title: "What factors help customers feel confident about buying from your brand?",
        hint: "Think about what reassures them — e.g. reviews, guarantees, clear return policies, trust badges, or brand reputation.",
        example: "The volume of detailed reviews from sceptics who converted, the dentist endorsement, and a money-back guarantee."
      },
      {
        id: "customer_journey_11",
        tag: "Customer journey",
        tagSub: "Retention.",
        title: "Do your customers typically buy once or do they return regularly?",
        hint: "Think about how many customers in your store have bought more than once.",
        example: "About 60% come back within 90 days — once they've made the switch they tend to stick with it."
      },
      {
        id: "customer_journey_12",
        tag: "Customer journey",
        tagSub: "Return triggers.",
        title: "What motivates customers to return?",
        hint: "Think about what triggers their return — running out, a new launch, a seasonal need, or simply brand loyalty.",
        example: "Mostly running out — we send a replenishment reminder email at the 7-week mark."
      }
    ]
  }
];